import {
  Button,
  CardContent,
  SecondaryFormDropdown,
} from 'former-kit'
import PropTypes from 'prop-types'
import { applySpec, map, prop } from 'ramda'
import React, { useState } from 'react'
import Card from '../Card'
import styles from './styles.css'

const parseOptions = map(applySpec({
  name: prop('label'),
  value: prop('value'),
}))

const DropdownOptions = ({
  children,
  handleSubmit,
  isLastQuestion,
  options,
  placeholderPath,
  t,
}) => {
  const [value, setValue] = useState(null)

  const buttonLabelPath = isLastQuestion
    ? 'pages.onboarding.last_step'
    : 'pages.onboarding.advance_step'

  const placeholder = placeholderPath
    ? t(placeholderPath)
    : ''

  return (
    <div className={styles.dropDownOptions}>
      <Card>
        <CardContent>
          <SecondaryFormDropdown
            name="onboarding"
            options={parseOptions(options)}
            onChange={e => setValue(e.target.value)}
            value={value}
            placeholder={placeholder}
          />
        </CardContent>
      </Card>

      {children}

      <Button
        disabled={!value}
        onClick={() => handleSubmit(value)}
        size="huge"
      >
        {t(buttonLabelPath)}
      </Button>
    </div>
  )
}

DropdownOptions.propTypes = {
  children: PropTypes.node,
  handleSubmit: PropTypes.func.isRequired,
  isLastQuestion: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  placeholderPath: PropTypes.string,
  t: PropTypes.func.isRequired,
}

DropdownOptions.defaultProps = {
  children: null,
  isLastQuestion: false,
  options: [],
  placeholderPath: '',
}

export default DropdownOptions
